import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useSelectedBookingDateStore} from './store';

const useResolvedBookingDate = (): string => {
	const selectedBookingDate = useSelectedBookingDateStore(state => state.selectedBookingDate);
	const bookingData = useBookingStore(state => state.bookingData);

	if (selectedBookingDate) return selectedBookingDate;

	return bookingData.dateAt || '';
};

export {useResolvedBookingDate};
